// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Root Color Variables */
:root {
  --primary-white: #fff;
  --primary-black: #000;
  --primary-grey: #73739a;
  --primary-blue: #6d72f6;
  --primary-green: #08ce8a;
  --primary-black2: #1c1c57;
}

.contact-header {
  position: relative;
  height: 60vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 2rem;
  animation: fadeIn 1.5s ease-in-out;
}

.contact-img-box{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  inset: -130px 0 0;
}

.contact-img-box img{
  width: 100%;
  height: 100vh;
}

.content {
  position: relative;
  z-index: 1;
}

.content h1 {
  font-size: 3rem;
  margin: 0;
  font-weight: bold;
}

.content h1 .highlight {
  color: var(--primary-blue);
  transition: color 0.5s ease-in-out;
}

.content h1 .highlight:hover {
  color: var(--primary-green);
}

.content p {
  font-size: 1.5rem;
  font-weight: 600;
  margin-top: 0.5rem;
}

/* Social Media Icons */
.social-icons {
  position: absolute;
  right: 2rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  z-index: 1;
}

.social-icons a {
  width: 40px;
  height: 40px;
  display: flex;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  border: 1px solid #dfdfdf;
  color: var(--primary-black2);
  background-color: var(--primary-white);
  transition: background-color 0.3s, transform 0.3s;
}

.social-icons a:hover {
  transform: scale(1.2);
  color: var(--primary-white);
  border-color: var(--primary-blue);
  box-shadow: 0px 2px 10px #6d72f6;
  background-color: var(--primary-blue);
}

/* Animations */
@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .content h1 {
    font-size: 2rem;
  }
  .content p {
    font-size: 1.2rem;
  }
  .social-icons {
    right: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/ContactHeader/ContactHeader.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,4BAA4B;EAC5B,sCAAsC;EACtC,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,iCAAiC;EACjC,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;AACF","sourcesContent":["/* Root Color Variables */\n:root {\n  --primary-white: #fff;\n  --primary-black: #000;\n  --primary-grey: #73739a;\n  --primary-blue: #6d72f6;\n  --primary-green: #08ce8a;\n  --primary-black2: #1c1c57;\n}\n\n.contact-header {\n  position: relative;\n  height: 60vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  padding: 2rem;\n  animation: fadeIn 1.5s ease-in-out;\n}\n\n.contact-img-box{\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  inset: -130px 0 0;\n}\n\n.contact-img-box img{\n  width: 100%;\n  height: 100vh;\n}\n\n.content {\n  position: relative;\n  z-index: 1;\n}\n\n.content h1 {\n  font-size: 3rem;\n  margin: 0;\n  font-weight: bold;\n}\n\n.content h1 .highlight {\n  color: var(--primary-blue);\n  transition: color 0.5s ease-in-out;\n}\n\n.content h1 .highlight:hover {\n  color: var(--primary-green);\n}\n\n.content p {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-top: 0.5rem;\n}\n\n/* Social Media Icons */\n.social-icons {\n  position: absolute;\n  right: 2rem;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  z-index: 1;\n}\n\n.social-icons a {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  border-radius: 50%;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #dfdfdf;\n  color: var(--primary-black2);\n  background-color: var(--primary-white);\n  transition: background-color 0.3s, transform 0.3s;\n}\n\n.social-icons a:hover {\n  transform: scale(1.2);\n  color: var(--primary-white);\n  border-color: var(--primary-blue);\n  box-shadow: 0px 2px 10px #6d72f6;\n  background-color: var(--primary-blue);\n}\n\n/* Animations */\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (max-width: 768px) {\n  .content h1 {\n    font-size: 2rem;\n  }\n  .content p {\n    font-size: 1.2rem;\n  }\n  .social-icons {\n    right: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
